import { render, staticRenderFns } from "./VasionStaticFields.vue?vue&type=template&id=a7597104&scoped=true&"
import script from "./VasionStaticFields.vue?vue&type=script&lang=js&"
export * from "./VasionStaticFields.vue?vue&type=script&lang=js&"
import style0 from "./VasionStaticFields.vue?vue&type=style&index=0&id=a7597104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7597104",
  null
  
)

export default component.exports